import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface CookieConsentContextType {
  hasConsent: boolean;
  setHasConsent: (value: boolean) => void;
}

const CookieConsentContext = createContext<CookieConsentContextType | undefined>(undefined);

export function CookieConsentProvider({ children }: { children: ReactNode }) {
  const [hasConsent, setHasConsent] = useState<boolean>(() => {
    const stored = localStorage.getItem('cookieConsent');
    return stored === 'true';
  });

  useEffect(() => {
    localStorage.setItem('cookieConsent', hasConsent.toString());
  }, [hasConsent]);

  return (
    <CookieConsentContext.Provider value={{ hasConsent, setHasConsent }}>
      {children}
    </CookieConsentContext.Provider>
  );
}

export function useCookieConsent() {
  const context = useContext(CookieConsentContext);
  if (context === undefined) {
    throw new Error('useCookieConsent must be used within a CookieConsentProvider');
  }
  return context;
}